/**
 * @desc 保存多个附件
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  body: defs.basics.BatchAssociatedFilesRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/associatedFiles/saveBatch`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
